module.exports = __webpack_public_path__ + "img/gesture_five.9998bf8f.png";